import { observer } from "mobx-react-lite";
import { TabHeader, TabHeaderProps } from "../tabs/TabHeader";
import React, { useContext } from "react";
import { SanContext } from "../schema";

export const ConfigViewTabHeader = observer((props: TabHeaderProps) => {
  const SAN = useContext(SanContext);

  const { tabs, ...rest } = props;
  const ctx = { data: SAN.oneDataSource.one };
  const filteredTabs = tabs.filter(t => (t.if ? t.if(ctx) : true));

  return <TabHeader {...rest} tabs={filteredTabs} />;
});
